import { render, staticRenderFns } from "./DonationsTable.vue?vue&type=template&id=4e283bc0&scoped=true&"
import script from "./DonationsTable.vue?vue&type=script&lang=js&"
export * from "./DonationsTable.vue?vue&type=script&lang=js&"
import style0 from "./DonationsTable.vue?vue&type=style&index=0&id=4e283bc0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e283bc0",
  null
  
)

export default component.exports